import { useFieldAssetsOptions } from 'App/data-export/components/DataExport/DataExportModalDrawer/_utils/useFieldAssetsOptions'
import { BlocksSelect } from 'App/data-export/components/DataExport/DataExportModalDrawer/components/FieldAssetsSelects/components/BlocksSelect'
import { IrrigationZoneEmittersSelect } from 'App/data-export/components/DataExport/DataExportModalDrawer/components/FieldAssetsSelects/components/IrrigationZoneEmittersSelect'
import { PointsSelect } from 'App/data-export/components/DataExport/DataExportModalDrawer/components/FieldAssetsSelects/components/PointsSelect'
import { InputWrapper } from 'App/data-export/components/DataExport/InputWrapper'
import { dataExportStore } from 'App/data-export/store/dataExportStore'
import { translate } from 'i18n/i18n'
import React from 'react'
import { colors } from 'settings/colors'

export const FieldAssetsSelects = () => {
  const { formState, formErrors } = dataExportStore.useSelector((s) => s)
  const { blocksOptions, pointsOptions, irrigationZoneEmittersOptions } = useFieldAssetsOptions(formState)

  if (blocksOptions.length + pointsOptions.length + irrigationZoneEmittersOptions.length === 0) {
    return (
      <div css={{ fontSize: 14, fontStyle: 'italic', color: colors.red }}>
        {translate.phrases.banyanApp(
          'No items are available for data export on this property. Please contact your sales representative for assistance.',
        )}
      </div>
    )
  }

  return (
    <InputWrapper
      label={translate.phrases.banyanApp('Select Data Type')}
      description={translate.phrases.banyanApp('Please select at least one source below')}
      error={!!formErrors.fieldAssetIds}
    >
      <>
        {blocksOptions.length > 0 && <BlocksSelect options={blocksOptions} />}
        {pointsOptions.length > 0 && <PointsSelect options={pointsOptions} />}
        {irrigationZoneEmittersOptions.length > 0 && (
          <IrrigationZoneEmittersSelect options={irrigationZoneEmittersOptions} />
        )}
      </>
    </InputWrapper>
  )
}
